// @flow
import React, { type Node } from 'react';
import styled from 'styled-components';

// Styles
export const StyledCheckbox = styled.label`
  display: block;
  position: relative;
  padding-left: 2rem;
  margin: 1em 0;
  cursor: pointer;
  user-select: none;
  color: ${({ theme }) => theme.colors.text};
  line-height: 1.5rem;
  text-align: left;
  letter-spacing: 0.05em;

  &:last-child {
    margin-bottom: 0;
  }

  a {
    color: ${({ theme }) => theme.colors.acc1};
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border: 1px solid ${({ theme }) => theme.colors.acc1};
    transition: all ${({ theme }) => theme.animation.fast};

    &::after {
      content: '';
      position: absolute;
      display: block;
      transform: scale(0);
      opacity: 0;
      transition: all ${({ theme }) => theme.animation.fast};
      left: 6px;
      top: 1px;
      width: 6px;
      height: 13px;
      border: solid ${({ theme }) => theme.colors.white};
      border-width: 0 1px 1px 0;
      transform: rotate(-45deg) scale(0);
    }
  }

  &:hover input ~ .checkmark,
  input:focus ~ .checkmark {
    background-color: ${({ theme }) => theme.colors.lightBlue};
  }

  input:focus ~ .checkmark {
    /* box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.gaisiZals}; */
    background-color: ${({ theme }) => theme.colors.lightBlue};
  }

  & input:checked ~ {
    .checkmark {
      border-color: ${({ theme }) => theme.colors.acc1};
      background-color: ${({ theme }) => theme.colors.acc1};
      box-shadow: none;

      &::after {
        opacity: 1;
        transform: rotate(45deg) scale(1);
      }
    }

    .label {
      color: ${({ theme }) => theme.colors.acc1};
    }
  }
`;

// Checkbox
type AsFormCheckboxPropsType = {
  name: string,
  checked: boolean,
  children: Node,
  onChange: (event: SyntheticInputEvent<HTMLInputElement>) => void,
};

const Checkbox = ({
  name,
  checked,
  children,
  onChange,
}: AsFormCheckboxPropsType) => (
  <StyledCheckbox htmlFor={`as-form__${name}`}>
    <input
      id={`as-form__${name}`}
      name={name}
      checked={checked}
      type="checkbox"
      onChange={onChange}
    />
    <span className="checkmark" />
    <span className="label">{children}</span>
  </StyledCheckbox>
);

export default Checkbox;
